import * as React from 'react';
import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { asDisplayText } from '../../helpers/dateTimeFormat';
import RulesSelectionPreview from './RulesSelectionPreview';

const PLAN_STATUS_LABELS = {
  draft: 'Rascunho',
  active: 'Ativo',
  retired: 'Arquivado',
};

// Visao somente-leitura do plano atrelado a uma fonte de dados -- reusa o
// array `plans` ja carregado na pagina (sem novo fetch) e o mesmo
// RulesSelectionPreview usado no formulario de politica, alimentado por
// getAdminPlanRules (ver PolicyGovernance/index.jsx).
export default function ClientPlanDetailsDialog({
  open,
  client,
  plan,
  rules,
  loading,
  errorMessage,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Plano da fonte de dados {client?.clientId ? `"${client.clientId}"` : ''}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {!plan ? (
            <Alert severity="info">
              Esta fonte de dados não tem uma política própria ativa vinculada a um plano-base no momento. Ela segue a política da organização.
            </Alert>
          ) : (
            <>
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Typography variant="subtitle1">{plan.name}</Typography>
                <Chip size="small" label={plan.code} />
                <Chip
                  size="small"
                  label={PLAN_STATUS_LABELS[plan.status] || asDisplayText(plan.status)}
                  color={plan.status === 'active' ? 'success' : 'default'}
                />
              </Stack>
              <Stack direction="row" spacing={3} flexWrap="wrap">
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Segmento: {asDisplayText(plan.targetSegment)}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Versão: {asDisplayText(plan.version)}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Vigência: {asDisplayText(plan.effectiveFrom)} até {asDisplayText(plan.effectiveTo, 'em aberto')}
                </Typography>
              </Stack>

              <RulesSelectionPreview
                title="Grupos de regras regulatórias do plano"
                subtitle="Regras herdadas por esta fonte de dados através da política ativa vinculada a este plano."
                rules={rules}
                loading={loading}
                errorMessage={errorMessage}
                emptyMessage="Nenhuma regra configurada para este plano."
              />
            </>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
